import { render, staticRenderFns } from "./VendasRadar.vue?vue&type=template&id=47d9a32c&scoped=true"
import script from "./VendasRadar.vue?vue&type=script&lang=js"
export * from "./VendasRadar.vue?vue&type=script&lang=js"
import style0 from "./VendasRadar.vue?vue&type=style&index=0&id=47d9a32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9a32c",
  null
  
)

export default component.exports